import InviteTravelTogether from '@/views/InviteTravelTogether/index.vue'

const InviteTravelTogetherRouter = {
  path: '/invite-travel-together',
  name: 'InviteTravelTogether',
  component: InviteTravelTogether,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default InviteTravelTogetherRouter
